/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum SystemEventName {
  autoUpdateCandidateBookDirectOffer = "autoUpdateCandidateBookDirectOffer",
  autoUpdateProfileStatus = "autoUpdateProfileStatus",
  conversations = "conversations",
  clearCache = "clearCache",
  dailyCron = "dailyCron",
  deleteCandidatesSavedOpportunities = "deleteCandidatesSavedOpportunities",
  deleteExpiredTokens = "deleteExpiredTokens",
  candidates = "candidates",
  reindex = "reindex",
  hydrate = "hydrate",
  updateTos = "updateTos",
  loadRecommended = "loadRecommended",
  cronJob = "cronJob",
}

export const SystemEventNameDisplay: Record<SystemEventName, string> = {
  [SystemEventName.autoUpdateCandidateBookDirectOffer]: "Auto Update Candidate Book Direct Offer",
  [SystemEventName.autoUpdateProfileStatus]: "Auto Update Profile Status",
  [SystemEventName.conversations]: "Conversations",
  [SystemEventName.clearCache]: "Clear Cache",
  [SystemEventName.dailyCron]: "Daily Cron",
  [SystemEventName.deleteCandidatesSavedOpportunities]: "Delete Candidates Saved Opportunities",
  [SystemEventName.deleteExpiredTokens]: "Delete Expired Tokens",
  [SystemEventName.candidates]: "Candidates",
  [SystemEventName.reindex]: "Reindex",
  [SystemEventName.hydrate]: "Hydrate",
  [SystemEventName.updateTos]: "Update Tos",
  [SystemEventName.loadRecommended]: "Load Recommended",
  [SystemEventName.cronJob]: "Cron Job",
};
